import React from 'react';
import PropTypes from 'prop-types';

import './Price.scss';

/**
 * Displays old and new price within a Product
 */

const PriceComponent = (props) => {
  const pricing = props.price;
  const hasDiscount = pricing.discounted !== '';

  let currentPrice;
  let originalPrice;
  if (hasDiscount) {
    currentPrice = pricing.discounted;
    originalPrice = <del className="price-component__original">{pricing.original}</del>;
  } else {
    currentPrice = pricing.original;
  }

  return (
    <p className="price-component u-fontSize-xl u-margin-0">
      {currentPrice} {originalPrice}
    </p>
  );
};

PriceComponent.displayName = 'Price';

PriceComponent.propTypes = {
  price: PropTypes.shape({
    /**
     * Original price formatted according to user locale
     */
    original: PropTypes.string.isRequired,
    /**
     * Discounted price formatted according to user locale
     */
    discounted: PropTypes.string.isRequired,
  }).isRequired,
};

export default PriceComponent;
